export default __webpack_public_path__ + "static/media/shoppers.00f8ab43.PNG";